import { render } from "./Search.vue?vue&type=template&id=54f18d9c&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "./Search.vue?vue&type=style&index=0&id=54f18d9c&scoped=scoped&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f18d9c"]])

export default __exports__